import { Contact } from 'model/contact';

/**
 * Contact Status Enum
 * Tracks the current state of contact operations
 */
export enum ContactStatus {
    Initial,
    Error,
    Fetching,
    FetchSuccess,
    Saving,
    SaveSuccess,
    Deleting,
    DeleteSuccess
}

/**
 * Contacts State Interface
 * Represents the contacts slice of the Redux store
 */
export interface ContactsState {
    status: ContactStatus;
    loading: boolean;
    error?: string;
    savedContact?: Contact;
    contacts: Array<Contact>;
}
